/**
 * @generated SignedSource<<2d7e74c4a92920f0261b9c1352b8125d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type messageDefinitions_MessageDefinitionsQuery$variables = {
  filterByTextOpt?: string | null;
};
export type messageDefinitions_MessageDefinitionsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"messageDefinitionsTable_QueryFragment">;
};
export type messageDefinitions_MessageDefinitionsQuery = {
  response: messageDefinitions_MessageDefinitionsQuery$data;
  variables: messageDefinitions_MessageDefinitionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByTextOpt"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "internalTitle",
    "variableName": "filterByTextOpt"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "messageDefinitions_MessageDefinitionsQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "filterByTextOpt",
            "variableName": "filterByTextOpt"
          }
        ],
        "kind": "FragmentSpread",
        "name": "messageDefinitionsTable_QueryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "messageDefinitions_MessageDefinitionsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MessageDefinitionsAdminSchema",
            "kind": "LinkedField",
            "name": "MessageDefinitions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "MessageDefinitionsConnection",
                "kind": "LinkedField",
                "name": "MessageDefinitions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MessageDefinitionsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MessageDefinition",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "internalTitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "showUntil",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v1/*: any*/),
                "filters": [
                  "internalTitle"
                ],
                "handle": "connection",
                "key": "messageDefinitionsTable_MessageDefinitions",
                "kind": "LinkedHandle",
                "name": "MessageDefinitions"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "76db3d6235ec6d20a53ed35349179b76",
    "id": null,
    "metadata": {},
    "name": "messageDefinitions_MessageDefinitionsQuery",
    "operationKind": "query",
    "text": "query messageDefinitions_MessageDefinitionsQuery(\n  $filterByTextOpt: String\n) {\n  ...messageDefinitionsTable_QueryFragment_3I7qjQ\n}\n\nfragment createMessageDispatchButton_MessageDefinitionFragment on MessageDefinition {\n  id\n  internalTitle\n}\n\nfragment messageDefinitionsTable_MessageDefinitionFragment on MessageDefinition {\n  id\n  internalTitle\n  createdAt\n  showUntil\n  ...createMessageDispatchButton_MessageDefinitionFragment\n}\n\nfragment messageDefinitionsTable_QueryFragment_3I7qjQ on Query {\n  Admin {\n    MessageDefinitions {\n      MessageDefinitions(internalTitle: $filterByTextOpt) {\n        pageInfo {\n          endCursor\n          hasPreviousPage\n          hasNextPage\n          startCursor\n        }\n        edges {\n          node {\n            ...messageDefinitionsTable_MessageDefinitionFragment\n            id\n            __typename\n          }\n          cursor\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "eafdb80d27431fe1de241a8fcc05946d";

export default node;
